"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Checksum = void 0;
const tslib_1 = require("tslib");
const crc_32_1 = tslib_1.__importDefault(require("crc-32"));
// eslint-disable-next-line @typescript-eslint/no-var-requires
const compatCrc32 = require('crc32');
/**
 * Provide access to different checksum functions.
 */
class Checksum {
    /**
     * Computes the CRC32 checksum of a given string.
     * A JSON object checksum could be computed by converting the JSON object to a string with the help of the JSON.stringify() method.
     *
     * @param data The given string.
     * @param seed A unique seed that is used to create the checksum.
     * @returns Returns the checksum
     */
    static crc32(data, seed) {
        seed = typeof seed === 'string' ? parseInt(seed, 10) : seed;
        return crc_32_1.default.str(data, seed);
    }
    /**
     * Computes the CRC32 checksum of a given string compatible to the npm-package "crc32", which has been used for iquote
     * formerly.
     *
     * @param data The given string.
     * @returns Returns the checksum converted to 2's complement hex as string.
     */
    static compatCrc32(data) {
        return compatCrc32(data);
    }
}
exports.Checksum = Checksum;
//# sourceMappingURL=checksum.js.map